export default "__VITE_ASSET__C991BYuP__"